import { render, staticRenderFns } from "./envoyer-mail-test-dialog.vue?vue&type=template&id=353b33de&scoped=true"
import script from "./envoyer-mail-test-dialog.vue?vue&type=script&lang=js"
export * from "./envoyer-mail-test-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b33de",
  null
  
)

export default component.exports